import { Button, Card, CardActions, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'

import { HowReliabilityIsMeasured } from 'components/getting-started/HowReliabilityIsMeasured'
import { WhatIsAReliabilityTest } from 'components/getting-started/WhatIsAReliabilityTest'
import { WhatIsAService } from 'components/getting-started/WhatIsAService'
import Icon from 'components/Icon'

import { DidYouKnow } from './DidYouKnow'

export const ReliabilityManagement101Tutorial: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(0)
  const maxPages = 4

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
  }

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
  }

  return (
    <Card data-test-reliability-management-tutorial>
      {currentPage === 0 && <WhatIsAReliabilityTest />}
      {currentPage === 1 && <WhatIsAService />}
      {currentPage === 2 && <HowReliabilityIsMeasured />}
      {currentPage === 3 && <DidYouKnow />}
      <CardActions>
        <Stack
          alignItems="center"
          direction="row"
          flex={1}
          justifyContent="space-between"
        >
          <Button
            data-testid="getting-started-previous-tutorial"
            disabled={currentPage === 0}
            size="small"
            startIcon={<Icon icon="arrowLeft" />}
            onClick={goToPreviousPage}
          >
            Back
          </Button>
          <Typography variant="body2">
            {currentPage + 1}/{maxPages}
          </Typography>
          <Button
            data-testid="getting-started-next-tutorial"
            disabled={currentPage === maxPages - 1}
            endIcon={<Icon icon="arrowRight" />}
            size="small"
            onClick={goToNextPage}
          >
            Next
          </Button>
        </Stack>
      </CardActions>
    </Card>
  )
}
